import React, { useState, useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { closeCollapsible, translate } from '../../../utils/util';
import BackButton from '../../../components/UI/BackButton';
import { TitleUI, SubtitleUI } from '../../../components/UI/LabelTitleUI';
import PrintListItem from './PrintListItem';
import * as configAction from '../../../actions/configAction';
import ConfigurationService from '../../../services/ConfigurationService';
import ConfirmModal from '../../../components/UI/ConfirmModal';
import { Input, Button, InfiniteScroll, Collapsible } from '../../../components/UI/ComponentsUI'
import { onValueChange } from '../../../utils/handleChangeHooks';
import useStateWithPromise from '../../../utils/useEffectUpdate';
import SelectNew from '../../../components/UI/SelectNew';
import { ENUMS } from '../../../utils/constants';

const PrintList = (props) => {
    const messageModal = useRef();
    const [prints, setPrints] = useState([]);
    const [currentPage, setCurrentPage] = useStateWithPromise(0);
    const [selectedId, setSelectedId] = useState(undefined);
    const [selectedPrinters, setSelectedPrinters] = useState([])
    const [filter, setFilter] = useState({});

    useEffect(() => {
        if (props.filters) {
            setFilter(props.filters);
            getPrints(props.filters)
        }
        else {
            searchPrints()
        }
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        if (props.prints?.items?.length > 0) {
            if (prints.length > 0 && currentPage === 0) {
                setPrints([...props.prints.items]);
            } else {
                setPrints((prevState) => ([...prevState, ...props.prints.items]));
            }
        } else {
            setPrints([]);
        }
        // eslint-disable-next-line
    }, [props?.prints?.items]);

    const onSelectItemChange = (item) => {
        props.setPrint(item);
    };

    const openModal = (id) => {
        setSelectedId(id)
        messageModal.current.show();
    }

    const deletePrinter = () => {
        props.deletePrint(selectedId, () => {
            messageModal.current.close();
            window.scrollTo(0, 0);
            if (currentPage > 0) {
                setCurrentPage(0)
            }
            setPrints([]);
        });
    };

    useEffect(() => {
        if (currentPage > 0) {
            getPrints();
        }
        // eslint-disable-next-line
    }, [currentPage]);


    const searchPrints = () => {
        if (currentPage > 0) {
            setCurrentPage(0)
        }

        getPrints(filter)
    }

    const getPrints = (filterSelected) => {
        props.getPrints(props.user.vision, {
            ...filterSelected,
            PageSize: 25,
            PageIndex: currentPage,
            sort: 'name',
            sortDir: 'ASC'
        });

        props.setPrintFilters(filterSelected)
        closeCollapsible("filterLogs");
    }

    const onChange = (event) => {
        onValueChange(event, filter, setFilter);
    };

    const deleteSelectedItems = () => {
        props.deleteSelected(selectedPrinters, () => {
            setCurrentPage(0)
            searchPrints()
        })
    }

    const onCheckItem = (item) => {
        let arr = [];
        Object.assign(arr, selectedPrinters);
        let index = selectedPrinters.findIndex((e) => e === item.printerId);
        if (index === -1) {
            arr.push(item.printerId)
        } else {
            arr.splice(index, 1);
        }
        setSelectedPrinters(arr)
    }

    return (
        <div>
            <BackButton {...props} />
            <div className="container-fluid h-65">
                <div className="row">
                    <TitleUI icon="mdi mdi-clipboard-check-outline" label={translate('menu.configuration', 'configuration')} />
                    <SubtitleUI icon="mdi mdi-printer" label={translate('menu.printer', 'configuration')} />
                </div>
            </div>
            <div className="container-fluid" style={{ marginTop: '30px' }}>
                <div className="container" style={{ marginTop: '0px', }}>
                    <Collapsible
                        id="filterPrinter"
                        header={translate('line-picking:linepicking.filter')}
                        body={
                            <>
                                <form id="getReport" className="col s12">
                                    <div className="row" style={{ padding: '10px' }}>
                                        <div className="input-field no-padding col s6">
                                            <Input
                                                id="name"
                                                name='name'
                                                label={translate('resource:name')}
                                                type="text"
                                                value={filter?.name || ''}
                                                onChange={onChange}
                                            />
                                        </div>
                                        <div className="input-field no-padding col s5">
                                            <Input
                                                id="address"
                                                name='address'
                                                label="Endereço IP"
                                                type="text"
                                                value={filter?.address || ''}
                                                onChange={onChange}
                                            />
                                        </div>
                                        <div className="input-field no-padding col s6">
                                            <Input
                                                id="macAddress"
                                                name='macAddress'
                                                label={translate('fields.macAddress', 'printer')}
                                                type="text"
                                                value={filter?.macAddress || ''}
                                                onChange={onChange}
                                            />
                                        </div>
                                        <div className="input-field no-padding col s5">
                                            <Input
                                                id="updateBy"
                                                name='updateBy'
                                                label={translate('resource:user')}
                                                type="text"
                                                value={filter?.updateBy || ''}
                                                onChange={onChange}
                                            />
                                        </div>
                                        <div className="input-field no-padding col s6">
                                            <SelectNew
                                                id="laser"
                                                name="laser"
                                                value={filter?.laser || ''}
                                                change={onChange}
                                                label={translate('printer.laser', 'configuration')}
                                                placeHolder={translate('general:choose-one-option')}
                                                data={[
                                                    { id: true, text: translate("yes", 'general') },
                                                    { id: false, text: translate("no", 'general') }
                                                ]}
                                            />
                                        </div>
                                        <div className="input-field no-padding col s5">
                                            <SelectNew
                                                required
                                                id="connectionType"
                                                name="connectionType"
                                                placeHolder={translate('choose-one-option', 'general')}
                                                label={translate('fields.connectionType', 'printer')}
                                                data={[{ id: ENUMS.ePrinterConnectionType.Wifi.value, text: ENUMS.ePrinterConnectionType.Wifi.text },
                                                { id: ENUMS.ePrinterConnectionType.Bluetooth.value, text: ENUMS.ePrinterConnectionType.Bluetooth.text }]}
                                                change={onChange}
                                                defaultValue={filter?.connectionType || ""}
                                            />
                                        </div>
                                    </div>
                                </form>
                                <div className="row" style={{ paddingTop: '5px' }}>
                                    <Button full="true" text="Buscar" onClick={() => searchPrints()} />
                                </div>
                            </>
                        }
                    />
                    {selectedPrinters.length > 0 &&
                        <div className="row" style={{ paddingTop: '5px' }}>
                            <Button full="true" text="Excluir Selecionados" onClick={() => deleteSelectedItems()} />
                        </div>
                    }
                </div>
                <InfiniteScroll
                    page={props.prints?.totalPages}
                    current={{ currentPage, setCurrentPage }}
                    hasMore={currentPage < props.prints?.totalPages}
                    data={prints.map((item, index) => {
                        return <PrintListItem
                            key={`oi-${index}`}
                            route={{ pathname: '../print/insert', state: { update: true } }}
                            data={item}
                            onSelectChange={() => onSelectItemChange(item)}
                            onDelete={(id) => openModal(id)}
                            onCheckItem={(item) => onCheckItem(item)}
                        />
                    })}
                />

            </div>
            <ConfirmModal
                ref={messageModal}
                id="messageModalDelete"
                data={{ title: translate('validations:attention'), message: translate("token.confirmation-delete", "configuration") }}
                onConfirm={deletePrinter}
                btnCancel={translate('cancel', 'general')}
                btnConfirm={translate('confirm', 'general')}
            />
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        user: state.userReducer.user,
        filter: state.locationReducer.filter,
        prints: state.configReducer.prints,
        filters: state.configReducer.printFilters
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getPrints: (vision, filter) => {
            dispatch(ConfigurationService.getPrints(vision, filter));
        },
        setPrint: (print) => {
            dispatch(configAction.setPrint(print));
        },
        setPrintFilters: (filters) => {
            dispatch(configAction.setPrintFilters(filters));
        },
        deletePrint: (printId, callback) => {
            dispatch(ConfigurationService.deletePrint(printId, callback));
        },
        deleteSelected: (selectedIds, callback) => {
            dispatch(ConfigurationService.deleteSelectedPrinter(selectedIds, callback));
        }
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PrintList));
